import k from "react";
import { useTheme as C, Container as T } from "@chakra-ui/react";
const V = ({
  children: E,
  shouldUseSpacingExtraLarge: L,
  styling: a,
  contentId: f,
  ...A
}) => {
  var p, u, b, d, M, x;
  const {
    siteMargin: o,
    breakpoint: e,
    content: {
      spacingExtraLarge: m,
      spacingExtraSmall: R,
      spacingLarge: c,
      spacingMedium: S,
      spacingSmall: t
    }
  } = C(), D = L ? m : c, r = (_) => ({
    EXTRA_SMALL: R,
    SMALL: t,
    MEDIUM: S,
    LARGE: c,
    EXTRA_LARGE: m,
    NONE: "0"
  })[_] || D;
  return /* @__PURE__ */ k.createElement(
    T,
    {
      "data-testid": "section",
      contentId: f,
      maxWidth: e == null ? void 0 : e.xlg,
      backgroundColor: a == null ? void 0 : a.backgroundColour,
      px: {
        base: o == null ? void 0 : o.xsmDefault,
        md: o == null ? void 0 : o.lgDefault,
        xl: o == null ? void 0 : o.xlgDefault
      },
      mt: {
        base: r((p = a == null ? void 0 : a.mobileMargin) == null ? void 0 : p.topMargin),
        md: r((u = a == null ? void 0 : a.tabletMargin) == null ? void 0 : u.topMargin),
        xl: r((b = a == null ? void 0 : a.desktopMargin) == null ? void 0 : b.topMargin)
      },
      mb: {
        base: r((d = a == null ? void 0 : a.mobileMargin) == null ? void 0 : d.bottomMargin),
        md: r((M = a == null ? void 0 : a.tabletMargin) == null ? void 0 : M.bottomMargin),
        xl: r((x = a == null ? void 0 : a.desktopMargin) == null ? void 0 : x.bottomMargin)
      },
      py: "0",
      ...A
    },
    E
  );
};
export {
  V as WrapperSection
};
